export default __webpack_public_path__ + "static/bg_hero-a881e8cdbc8ae8cefeb3ae188387a814.jpg";